//--------------------------------------------------------------------//
//******************** AgentSkillsService ******************************//
//--------------------------------------------------------------------//
// API communication layer for skill lifecycle management (create,
// update, delete, publish to Anthropic) on the agents server.
import { GUDHUB_SETTINGS } from '../../../config.js';
import { request } from '../agents.request.js';

angular.module('agentsTableModule')

    .service('AgentSkillsService', [function () {
        // Adds a skill to an agent. Creates a git repo via git-webserver (premade template or blank).
        this.addSkill = async function (agentId, data) {
            const token = await gudhub.getToken();
            const user = gudhub.storage.getUser();

            return request(`/agents/${encodeURIComponent(agentId)}/skills`, {
                ...data,
                token,
                user_id: user.user_id
            });
        };

        // Fetches all skills attached to an agent, including repo IDs and Anthropic skill IDs.
        this.getSkills = async function (agentId) {
            const token = await gudhub.getToken();

            return gudhub.req.get({
                url: `${GUDHUB_SETTINGS.agents_server_url}/agents/${encodeURIComponent(agentId)}/skills?token=${encodeURIComponent(token)}`,
                externalResource: true
            });
        };

        // Removes a skill from an agent and deletes it from Anthropic if uploaded.
        this.removeSkill = function (agentId, repoId) {
            return request(`/agents/${encodeURIComponent(agentId)}/skills/${encodeURIComponent(repoId)}/delete`);
        };

        // Updates a skill's metadata (name, description) in the agent's skill_repos array.
        this.updateSkill = function (agentId, repoId, data) {
            return request(`/agents/${encodeURIComponent(agentId)}/skills/${encodeURIComponent(repoId)}/update`, data);
        };

        // Fetches available premade skill templates for the create skill dialog.
        this.getPremadeSkills = async function () {
            const token = await gudhub.getToken();

            return gudhub.req.get({
                url: `${GUDHUB_SETTINGS.agents_server_url}/premade-skills?token=${encodeURIComponent(token)}`,
                externalResource: true
            });
        };

        // Fetches the user's own repositories of type "skills" from the
        // git-webserver, so they can be attached to an agent as-is.
        this.getSkillRepos = async function () {
            const token = await gudhub.getToken();

            const response = await fetch(`${GUDHUB_SETTINGS.git_server_url}/get-repos`, {
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json'
                }
            });
            const repos = await response.json();

            return (repos || []).filter(function (repo) {
                return repo.repo_type === 'skills';
            });
        };
    }]);
